import React from 'react'

import classes from './EmployeeInfo.scss'

const employeeInfo = ({ info }) => {
  return (
    <div className={classes.EmployeeInfo}>
      <div className={classes.EmpInfoHeader}>
        <div className={classes.Title}>{info?.full_name}</div>
        <div className={classes.Subtitle}>{info?.emp_code}</div>
      </div>
      <div className={classes.Content}>
        <div className={classes.EmpInfoData}>{info?.company_name}</div>
        <div className={classes.EmpInfoData}>{info?.organization?.org_name}</div>
        <div className={classes.EmpInfoData}>{info?.level?.level_name}</div>
        <div className={classes.EmpInfoData}>{info?.position?.position_name}</div>
      </div>
    </div>
  )
}

export default employeeInfo
